import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup
} from 'reactstrap';
import { ChromePicker } from 'react-color';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { setBackGroundColor } from '../../../integration/style/DigitalAssistantStyle';
export default function Appearance({ appearance, handleAppearance }) {
    const [appearanceData, setAppearanceData] = useState({});
    const [error, setError] = useState(true);
    const [edit, setEdit] = useState(true);
    let [iseditMode, setEditMode] = useState({ IconBackgroundColor: false, IconColor: false, });
    useEffect(() => {
        if (appearance === null) {
            setAppearanceData({ iconBackgroundColor: "#4A89DC", iconColor: "#FFF" });
        }
        else {
            setAppearanceData(appearance);
        }
    }, [appearance]);
    return (
        <Row>
            <Colxx xxs="12" className="mt-3">
                <div>
                    <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
                            <span className=''>Icon Background Color​</span>
                        </div>
                        <div className='col-md-12'>
                            <InputGroup>
                                <Input
                                    className=""
                                    type="text"
                                    onChange={(e) => {
                                        setAppearanceData({ ...appearanceData, iconBackgroundColor: e.target.value });
                                        handleAppearance({ ...appearanceData, iconBackgroundColor: e.target.value });
                                    }}
                                    value={appearanceData.iconBackgroundColor}
                                />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => {
                                        setEditMode({ ...iseditMode, IconBackgroundColor: !iseditMode.IconBackgroundColor });
                                    }}
                                        className="color-square" style={setBackGroundColor(appearanceData.iconBackgroundColor)}></InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                    </div>
                </div>
                {iseditMode.IconBackgroundColor && <div className='parent-div'>
                    <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2'
                            style={{ width: '200px' }}
                            color={appearanceData.iconBackgroundColor}
                            onChangeComplete={(e) => {
                                if (edit) {
                                    setAppearanceData({ ...appearanceData, iconBackgroundColor: e.hex });
                                    handleAppearance({ ...appearanceData, iconBackgroundColor: e.hex });
                                    setEditMode({ ...iseditMode, IconBackgroundColor: false });
                                } else setError(true);
                            }}
                        />
                    </div>
                </div>}
            </Colxx>
            <Colxx xxs="12" className="mt-3">
                <div>
                    <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
                            <span className=''>Icon Color</span>
                        </div>
                        <div className='col-md-12'>
                            <InputGroup>
                                <Input
                                    className=""
                                    type="text"
                                    onChange={(e) => {
                                        setAppearanceData({ ...appearanceData, iconColor: e.target.value });
                                        handleAppearance({ ...appearanceData, iconColor: e.target.value });
                                    }}
                                    value={appearanceData.iconColor}
                                />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => {
                                        setEditMode({ ...iseditMode, IconColor: !iseditMode.IconColor });
                                    }}
                                        className="color-square" style={setBackGroundColor(appearanceData.iconColor)}></InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                    </div>
                </div>
                {iseditMode.IconColor && <div className='parent-div'>
                    <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2'
                            style={{ width: '200px' }}
                            color={appearanceData.iconColor}
                            onChangeComplete={(e) => {
                                if (edit) {
                                    setAppearanceData({ ...appearanceData, iconColor: e.hex });
                                    handleAppearance({ ...appearanceData, iconColor: e.hex });
                                    setEditMode({ ...iseditMode, IconColor: false });
                                } else setError(true);
                            }
                            }
                        />
                    </div>
                </div>}
            </Colxx>
        </Row>
    )
}